import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Card, Label, Icon, Button, Message } from 'semantic-ui-react';

import SlidingPopup from 'modules/misc/SlidingPopup.js';
import LoadInline from 'modules/loading/LoadInline.js';
import TeamChallengeCard from './TeamChallengeCard.js';
import SelectTeamConfirm from 'modules/teamchallenges/SelectTeamConfirm.js';
import {colors, spacings} from 'style';

var style = {
    content: {
        padding: '1px',
        position:'relative'
    },
    segment: {
        border: 'none',
        boxShadow: 'none',
    },
    surveyCard: {
        overflow:'hidden',
        background:colors.themeBlue,
        color: '#fff',
        padding:'12px 5px 5px 5px', 
        maxHeight: '140px',
        width: '400px',
        marginTop: spacings.small,
        marginBottom: spacings.small,
        marginLeft: spacings.small,
        marginRight: spacings.small,
    },
    surveyTitle: {
        textAlign: 'center',
        color: '#fff',
        height:'25px', 
    },
    answerLabel: {
        textAlign: 'center',
        height:'50px',
        lineHeight:'50px',
        borderRadius: '25px',
        backgroundColor: '#fff',
        color: colors.themeBlue, 
        margin:'5px 5px 5px 5px', 
    },
    group: {
        alignItems: 'flex-start',
        justifyContent: 'center',
    }
};


const SurveyCard = ({t, card, onLaunch}) => (
    <Card style={style.surveyCard} onClick={()=>onLaunch(card.survey, card.micro)}>
        <div style={style.surveyTitle}>{card.survey.title}</div>
        <div style={style.answerLabel}>{t('Answer Questions')}</div>
        <div>{/*this affects the style*/}</div>
    </Card>
);

const LeaderboardCard = ({card, onClickLeaderboard}) => (
    <TeamChallengeCard leaderboard={card.leaderboard} 
                       onClickLeaderboard={onClickLeaderboard} />
    
);


const Cards = ({t, cards, selectedLeaderboard, onLaunchSurvey, onClickLeaderboard, onConfirmLeaderboard, onCancelLeaderboard, children}) => (
    <div style={style.content}>
    <Segment style={style.segment}>
    <Card.Group style={style.group}>
        {children}
        {cards.map((card)=>{
                switch(card.type) {
                    case 'survey':      return <SurveyCard key={card.id} t={t} card={card} onLaunch={onLaunchSurvey} />
                    case 'leaderboard': return <LeaderboardCard key={card.id} card={card} onClickLeaderboard={onClickLeaderboard} />
                    default: return null;
                }
            })
        }
    </Card.Group>
    
    </Segment>
    {selectedLeaderboard &&
    <SlidingPopup onClose={onCancelLeaderboard}>
        <SelectTeamConfirm leaderboard={selectedLeaderboard} onConfirm={onConfirmLeaderboard} />
    </SlidingPopup>
    }
    </div>
);
export default translate('surveys')(Cards);



// WEBPACK FOOTER //
// ./src/modules/cards/Cards.js